import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

function sleep(ms) {
  return new Promise((r) => setTimeout(r, ms));
}

/**
 * Genera un PDF horizontal a partir de bloques `[data-pdf-section]` dentro del contenedor.
 * Espera a que el navegador pinte (Recharts) antes de capturar.
 *
 * @param {{ fileBaseName: string, rootSelector?: string }} opts
 */
export async function exportPastoralChartsPdfFromDom({
  fileBaseName,
  rootSelector = "#pastoral-charts-pdf-capture",
}) {
  const root = document.querySelector(rootSelector);
  if (!root) {
    throw new Error("No se encontró el bloque de gráficas para exportar.");
  }

  await new Promise((r) => requestAnimationFrame(r));
  await new Promise((r) => requestAnimationFrame(r));
  await sleep(550);

  const sections = root.querySelectorAll("[data-pdf-section]");
  if (!sections.length) {
    throw new Error("No hay secciones preparadas para el PDF.");
  }

  const pdf = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: "a4",
    compress: true,
  });
  const pageW = pdf.internal.pageSize.getWidth();
  const pageH = pdf.internal.pageSize.getHeight();
  const margin = 18;
  const usableW = pageW - 2 * margin;
  const usableH = pageH - 2 * margin;

  let firstPage = true;
  for (const section of Array.from(sections)) {
    const canvas = await html2canvas(section, {
      scale: Math.min(2, window.devicePixelRatio || 2),
      backgroundColor: "#ffffff",
      useCORS: true,
      logging: false,
      scrollX: 0,
      scrollY: -window.scrollY,
      windowWidth: section.scrollWidth,
      windowHeight: section.scrollHeight,
    });

    let imgW = usableW;
    let imgH = (canvas.height * imgW) / canvas.width;
    if (imgH > usableH) {
      const s = usableH / imgH;
      imgH = usableH;
      imgW *= s;
    }
    const x = margin + (usableW - imgW) / 2;
    const y = margin + (usableH - imgH) / 2;

    if (!firstPage) pdf.addPage();
    firstPage = false;
    pdf.addImage(canvas.toDataURL("image/png", 1.0), "PNG", x, y, imgW, imgH, undefined, "FAST");
  }

  const safe = (fileBaseName || "graficas_ausencias").replace(/[^\w\-]+/g, "_");
  pdf.save(`${safe}.pdf`);
}
